import QuickActionImg from "@Assets/homePage/quick-action.png";
import { Flex } from "features/comments/modals/comment-center.style";
import AICreation from "features/journey-map/modals/AI/ai-creation.jsx";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { PromptAICreation } from "shared/modals";
import { Button } from "shared/ui-basics/buttons.js";
import { IconDispatcher } from "shared/ui-basics/index.js";
import styled from "styled-components";
import { useModal } from "use-modal-hook";

export const QuickActions = () => {
	const { t } = useTranslation();
	const history = useHistory();

	const userInfo = useSelector((state: any) => state.auth?.userInfo);
	const aiAllowed = useSelector(({ settings }) => settings.subscriptionDetails.aiEnabled);

	const [showJourneyAiModal] = useModal(AICreation);
	const [showPersonaAiModal] = useModal(PromptAICreation);

	const isEnterprise = userInfo.UserSubscriptionPlanName?.toLowerCase() === "enterprise";

	const handleRedirectCjmAI = () => {
		history.push(`/journey-map`);
		showJourneyAiModal();
	};

	const handleRedirectPersonaAI = () => {
		history.push(`/personas`);
		showPersonaAiModal();
	};

	return (
		<Container>
			<Body>
				<Title>{t("READY_MAP_NEXT_IDEA")}</Title>
				<Flex align="center" gap={16}>
					<Button variant="primary" size="s" onClick={() => history.push(`/map-creation`)}>
						<IconDispatcher type="map" styling="me-2" />
						<div>{t("START_NEW_JOURNEY")}</div>
					</Button>
					{isEnterprise && aiAllowed && (
						<>
							<Button variant="dark-outline" size="s" onClick={handleRedirectCjmAI}>
								<IconDispatcher type="SPARKLES" styling="me-2" />
								<div>{t("GENERATE_CJM_HEADER")}</div>
							</Button>
							<Button variant="dark-outline" size="s" onClick={handleRedirectPersonaAI}>
								<IconDispatcher type="PERSONA" styling="me-2" />
								<div>{t("GENERATE_AI_PERSONA")}</div>
							</Button>
						</>
					)}
				</Flex>
			</Body>
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	border-radius: 8px;
	border: 1px solid #d9d9d9;
	background: #fff;
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
	margin-bottom: 48px;
	background-image: url(${QuickActionImg});
	background-size: cover;
	background-position: center;
	width: 100%;
	height: 152px;
	max-width: 100%;
`;

const Body = styled.div`
	padding: 32px;
	display: flex;
	flex-direction: column;
	gap: 32px;
`;

const Title = styled.div`
	color: #262626;
	font-family: "Inter";
	font-size: 20px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;
